import { render } from "./RoleMaster.vue?vue&type=template&id=8d589920"
import script from "./RoleMaster.vue?vue&type=script&lang=js"
export * from "./RoleMaster.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__